<template>
  <div class="onlineReserve-add">
    <van-row type="flex" justify="center" class="row-title">
      <van-col span="24" class="col-title">
        <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="friends-o">
          婚姻状况承诺书
        </van-notice-bar>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-show">
      <van-col span="23" class="col-show">
        <van-panel title="婚姻状况承诺书说明" desc="" status="请知悉">
          <div class="reser-content">
            <p>
              1、婚姻状况承诺书提交成功，前往查询窗口办理业务时，请打开不动产登记中心微信公众号，出示婚姻状况承诺书信息给工作人员查验。
            </p>
            <p>
              <van-cell is-link @click="viewCode()">
                用户操作二维码查看
              </van-cell>
              <van-popup v-model="showCode" class="codeImg">
                <img src="../../assets/images/code.png" width="100%">
              </van-popup>
            </p>
          </div>
        </van-panel>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-tip">
      <van-col span="24" class="col-tip">
        <van-divider
          :style="{ color: '#999', borderColor: '#999', padding: '0 16px' }"
        >
          婚姻状况承诺书信息
        </van-divider>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-form">
      <van-col span="23" class="col-from">
        <van-field v-model="delegateApplication.Name" label="承诺人" placeholder="请输承诺人姓名" readonly required/>
        <van-field v-model="delegateApplication.MobilePhone" label="联系电话" placeholder="请输入联系电话" required/>
        <van-field v-model="delegateApplication.IdNumber" label="证件号码" placeholder="请输入证件号码" readonly required/>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-tip">
      <van-col span="24" class="col-tip">
        <van-divider
          :style="{ color: '#999', borderColor: '#999', padding: '0 16px' }"
        >
          产权信息
        </van-divider>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-form">
      <van-col span="23" class="col-from">
      <van-field v-model="delegateApplication.CertificateNumber" label="不动产权证号" placeholder="不动产权证号或合同备案号需填写一项" />
        <van-field v-model="delegateApplication.ContractNumber" label="合同备案号" placeholder="合同备案号或不动产权证号需填写一项" />
        <van-field v-model="delegateApplication.RealPropLoc" label="房屋坐落" placeholder="请输入房屋坐落" required/>
        <van-field
          v-model="Relation"
          v-validate="{required:true}"
          readonly
          clickable
          name="picker"
          label="婚姻状况"
          placeholder="点击选择婚姻状况"
          required
          :rules="[{ required: true, message: '请选择婚姻状况' }]"
          @click="showRelationPicker = true"
        />
        <van-popup v-model="showRelationPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="allRelationList"
            @confirm="onRelationConfirm"
            @cancel="showRelationPicker = false"
          />
        </van-popup>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-tip">
      <van-col span="24" class="col-tip">
        <van-divider
          :style="{ color: '#999', borderColor: '#999', padding: '0 16px' }"
        >
          婚姻状况承诺书-人像照片信息
        </van-divider>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-form">
      <van-col span="23" class="col-from">
        <van-field name="uploader2" label="申请人人像自拍照片" required>
          <template #input>
            <van-uploader v-model="uploader2" :max-count="1" :after-read="afterRead" />
          </template>
        </van-field>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-button">
      <van-col span="22" class="col-button">
        <van-button round block type="info" native-type="submit" @click="handleSubmit()">
          确认提交
        </van-button>
      </van-col>
    </van-row>
  </div>
</template>

<script type="text/javascript">
import { addDelegate, getIdCardIs, uploadCaseAttach } from '@/api/deletate'
import { mapGetters } from 'vuex'
import { Notify, Toast, Uploader } from 'vant'
import Vue from 'vue'
import { detectAuth2, getDetectInfo2, getFaceUrl, getFaceDate, addFaceDate,getFaceDateById } from '@/api/faceid'
import { v4 as uuidv4 } from 'uuid'

const qs = require('qs')
const url = require('url')

Vue.use(Uploader)
export default {
  components: {},
  data() {
    return {
      isShow: false,
      showCode: false,
      uploader: [],
      uploader2: [],
      compressFile: {},
      base64: '',
      StartTime: '2022/4/15',
      EndTime: '2022/4/15',
      QDFS: '',
      adfsList: [{ key: '出让', text: '出让', value: '出让' }, { key: '划拨', text: '划拨', value: '划拨' }],
      Relation: '',
      allRelationList: ['未婚', '未再婚(离婚/丧偶后)'],
      delegateApplication: {
        Name: '',
        AssignorId: '',
        IdNumber: '',
        MobilePhone: '',
        StartTime: '',
        EndTime: '',
        ApplicationTime: '',
        Reason: '',
        AgentName: '3',
        AgentIdNumber: '',
        AgentMobilePhone: '3',
        Relation: '',
        CertificateNumber: '',
        ContractNumber: '',
        RealPropLoc: '',
        MJ: '',
        QDFS: '',
        DelegateType: '3'
      },
      showStartTime: false,
      showEndTime: false,
      showResonPicker: false,
      showRelationPicker: false,
      idNumber: '',
      realName: '',
      realNameSFZ: '',
      detectAuthParams: {
        redirectUrl: '',
        extra: '',
        imageBase64: '',
        name: '',
        idCard: ''
      },
      faceData: {
        jump_wxa: {
          path: '/pages/login/loginFace',
          query: '',
          env_version: 'release'
        },
        is_expire: true,
        expire_type: 1,
        expire_interval: 1
      },
      uuid: '',
      openId: '',
      faceParam: {
        uuid: '',
        openId: ''
      },
      show: false,
      faceAddData: {
        Uuid: ''
      }
    }
  },
  computed: {
    ...mapGetters(['webUserInfo'])
  },
  mounted() {
     // 获取url对象
     const urlObj = url.parse(window.location.href)
    console.info(urlObj)
    if (urlObj.query === null) {
      localStorage.removeItem('delegateData')
      this.delegateApplication.Name = this.webUserInfo.realName
      this.delegateApplication.IdNumber = this.webUserInfo.idNumber
      this.delegateApplication.AssignorId = this.webUserInfo.id
      this.delegateApplication.MobilePhone = this.webUserInfo.mobilePhone
      this.realName = this.webUserInfo.realName
      this.realNameSFZ = this.webUserInfo.realName + '身份证正面'
      this.idNumber = this.webUserInfo.idNumber
    } else {
      // 获取查询对象
      localStorage.removeItem('delegateData')
      this.delegateApplication.Name = this.webUserInfo.realName
      this.delegateApplication.IdNumber = this.webUserInfo.idNumber
      this.delegateApplication.AssignorId = this.webUserInfo.id
      this.delegateApplication.MobilePhone = this.webUserInfo.mobilePhone
      this.realName = this.webUserInfo.realName
      this.realNameSFZ = this.webUserInfo.realName + '身份证正面'
      this.idNumber = this.webUserInfo.idNumber
    }
  },
  methods: {
    onStartTimeConfirm(date) {
      this.StartTime = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
      this.delegateApplication.StartTime = this.StartTime
      this.showStartTime = false
    },
    onEndTimeConfirm(date) {
      this.EndTime = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
      this.delegateApplication.EndTime = this.EndTime
      this.showEndTime = false
    },
    onReasonConfirm(reason) {
      Toast(reason.text)
      this.showResonPicker = false
      this.Reason = reason.text
      this.delegateApplication.Reason = reason.value
    },
    onRelationConfirm(relation) {
      this.Relation = relation
      this.delegateApplication.Relation = relation
      this.showRelationPicker = false
    },
    handleSubmit() {
      if (this.uploader2.length === 0) {
        Toast.fail('人像照片未上传')
        Notify({ type: 'danger', message: '请上传人像照片信息' })
        return
      }
      if (!this.delegateApplication.CertificateNumber && !this.delegateApplication.ContractNumber) {
        Toast.fail('不动产权证号或合同备案号需填写一项')
        Notify({ type: 'danger', message: '请填写完整授权信息' })
        return
      }
      // if (!this.delegateApplication.StartTime || !this.delegateApplication.EndTime || !this.delegateApplication.Reason || !this.delegateApplication.Relation) {
      //   Toast.fail('内容不能为空')
      //   Notify({ type: 'danger', message: '请填写完整授权信息' })
      //   return
      // }
      Toast.loading({
        message: '提交中...',
        forbidClick: true
      })
      getIdCardIs({ idCard: this.idNumber })
        .then(response => {
          Toast.clear()
          if (response.data === '' && this.uploader.length === 0) { // 未上传身份证信息
            Notify({ type: 'danger', message: '请上传发起人身份证正面照！' })
            this.isShow = true
          } else if (response.data === '' && this.uploader.length > 0) { // 未上传身份证信息，本次已上传
            Notify({ type: 'primary', message: '提交中！' })
            const formData = new FormData()
            formData.append('file', this.compressFile)
            formData.append('idCard', this.idNumber)
            // 上传附件至服务端
            uploadCaseAttach(formData).then(response => {
              this.detectAuthParams.imageBase64 = this.base64
              detectAuth2(this.detectAuthParams)
                .then(data => {
                  localStorage.setItem('delegateData', JSON.stringify(this.delegateApplication))
                  // 重定向至人脸核身页面
                  window.location.replace(data.data.url)
                })
                .catch(error => {
                  console.log(error)
                  // Toast.fail('提交失败')
                  Notify({ type: 'danger', message: '请重新上传发起人身份证正面照！' })
                  this.isShow = true
                })
            }).catch(error => {
              console.info(error)
            })
          } else { // 已有身份证信息，直接鉴权
            // 生成随机的UUID
            var randomUUID = uuidv4()
            this.uuid = randomUUID
            this.faceAddData.Uuid = this.uuid
            addFaceDate(this.faceAddData)
              .then( async(response) => {
                let encodedParam = encodeURIComponent(this.realName)// 将中文参数进行编码
                let query = `name=${encodedParam}&idCard=${this.idNumber}&uuid=${randomUUID}`
                this.faceData.jump_wxa.query = query
                let res = await getFaceUrl(this.faceData);
                if (res.status === 200 && res.data) {
                  const toast = Toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: '正在验证，请稍待....',
                  });
                  window.location.href = res.data.openlink;
                  this.myTimeOut();
                } else {
                  Toast.fail('提交失败')
                }
              })
              .catch(error => {
                console.log(error)
                Toast.fail('提交失败')
              })
           
          }
        })
        .catch(error => {
          console.log(error)
          Toast.clear()
          Notify({ type: 'danger', message: '未读取到身份证照片信息' })
          return
        })
    },
    loadDetectResponse(biz) {
      getDetectInfo2({ bizToken: biz })
        .then(response => {
          if (response.data.detectInfo.text.errCode === '0') {
            addDelegate(this.delegateApplication)
              .then(response => {
                localStorage.removeItem('delegateData')
                Notify({ type: 'success', message: '授权委托操作成功！' })
                Toast.clear()
                setTimeout(() => {
                  // 跳转页面
                  this.$router.push({
                    path: '/'
                  })
                }, 1000)
              })
              .catch(error => {
                console.log(error)
                Toast.fail('提交失败')
                Notify({ type: 'danger', message: '重复提交委托信息' })
              })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    afterRead(file, detail) {
      if (file.file.size > 100000) {
        const num = Math.sqrt(100000 / file.file.size) // 获取图片的压缩比例
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        const img = new Image()
        img.src = file.content
        img.onload = () => { // 固定宽高
          canvas.width = img.width * num
          canvas.height = img.height * num
          context.drawImage(img, 0, 0, canvas.width, canvas.height)
          file.content = canvas.toDataURL(file.file.type, 1) // 0.92为默认压缩质量
          this.compressFile = this.dataURLtoFile(file.content, file.file.name)
        }
      }
    },
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      this.base64 = arr[1]
      return new File([u8arr], filename, { type: mime })
    },
    viewCode() {
      this.showCode = true
    },
    myTimeOut(){
      //轮询是否验证成功
      this.faceParam.uuid = this.uuid
      setTimeout(() => {
        //定时任务
        const timer = setInterval(() => {
          getFaceDateById(this.faceParam)
              .then(response => {
                if(response.data.isVerify === "1"){
                  const formData = new FormData()
                  formData.append('file', this.compressFile)
                  formData.append('idCard', this.idNumber)
                  formData.append('type', 'photo')
                  // 上传附件至服务端
                  uploadCaseAttach(formData).then(response => {
                    addDelegate(this.delegateApplication)
                    .then(response => {
                      localStorage.removeItem('delegateData')
                      Notify({ type: 'success', message: '授权委托操作成功！' })
                      setTimeout(() => {
                        // 跳转页面
                        this.$router.push({
                          path: '/'
                        })
                      }, 1000)
                      Toast.clear()
                      //销毁Interval
                      clearInterval(timer)
                    })
                    .catch(error => {
                      console.log(error)
                      Toast.fail('提交失败')
                      Notify({ type: 'danger', message: '重复提交委托信息' })
                    })
                  }).catch(error => {
                    console.info(error)
                  })
                  Toast.success('人脸核身验证成功！')
                } else if (response.data.isVerify === "0"){
                  Toast.fail('非本人认证，认证失败')
                } else {
                  Toast.fail('认证失败')
                }
                Toast.clear()
              })
              .catch(error => {
                Toast.fail('认证失败')
              })
        }, 2000)//2秒轮询一次
      }, 8000);
    }
  }
}
</script>

<style lang="scss" scoped>
  .onlineReserve-add{
    min-height: 100vh;
    background-color: #F1F0F8;
    .col-tip{
      p{
        margin-left: 5px;
        font-weight: bold;
        font-size: 0.8em;
      }
    };
    .row-button{
      margin-top: 20px;
    }
    .row-show{
      margin-top: 16px;
      .col-show{
        .reser-content{
          padding: 5px 0;
          p{
            margin: 0 16px 0;
            font-size: 0.8em;
            color: #666;
          }
        }
      }
    }
    .row-button{
      margin-top: 50px;
    }
  }
